
import { defineComponent } from 'vue';
import { Field, ErrorMessage } from 'vee-validate';
import { handleValidationMessage } from '@/utils/localization';


export default defineComponent({
    name: 'FormTextBox',
    emits: ['input','update:modelValue'],
    components: {
        Field,
        ErrorMessage
    },
    props: {
        name: { type: String, required: true },
        type: { type: String, default: 'text' },
        langKey: { type: String, required: true },
        rules: null,
        placeholder: { type: String, default: '' },
        min: { type: Number, default: 0 },
        cssClass: { type: String, default: '' },
        hasTooltip: { type:Boolean, default: false },
        required: Boolean,
        disabled: Boolean,
        modelValue: [String, Number]
    },
    computed: {
        inputType: function(): string {
            if(this.type == 'phone') {
                return 'text'
            } else if(this.type == 'currency') {
                return 'text'
            } else if(this.type == 'date') {
                return 'text'
            }
            return this.type
        },
        cleave: function(): any {
            if(this.type == 'phone') {
                return {
                    numericOnly: true,
                    blocks: [3, 3, 4],
                    delimiters: ["-", "-", "-"]
                }
            } else if(this.type == 'currency') {
                return {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                    numeralPositiveOnly: true,
                    numeralDecimalScale: 2,
                    prefix: '$ ',
                }
            } else if(this.type == 'date') {
                return {
                    date: true,
                    datePattern: ['m', 'd', 'Y'],
                    delimiter: '/'
                }
            }
            return null;
        }
    },
    data() {
        return {
            input: this.modelValue || (this.type == 'currency' ? '$ ' : '')
        }
    },
    watch: {
        modelValue(newVal) {
            if(this.type == 'currency') {
                this.input = "$ " + newVal.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
            } else {
                this.input = newVal;
            }
        },
        input(newVal) {
            let value;
            if(this.type == 'currency') {
                value = parseFloat(newVal.replace(/[^0-9.]/g, ''));
                if (isNaN(value)) {
                    value = 0
                }
            } else {
                value = newVal;
            }
            this.$emit('update:modelValue', value);
            this.$emit('input', value);
        }
    },
    mounted() {
        if(this.hasTooltip) {
            const w: any = window;
            w.$(`#tooltip${this.name}`).tooltipster({
                theme: 'tooltipster-WDI',
                delay: 100,
                animation: 'grow',
                trigger: 'click',
                maxWidth: '250'
            });
        }
    },
    methods: {
        handleValidationMessage: handleValidationMessage
    }
})
